import { useEffect, useRef, useState, useSyncExternalStore } from "react";
import { useLocation } from "react-router-dom";
import analytics, { CONSENT_KEY, safeRoute } from "../services/analytics";

export default function AnalyticsControls() {
  const { pathname } = useLocation();
  const consent = useSyncExternalStore(analytics.subscribe, analytics.getConsent);
  const lastPage = useRef(null);
  const [preferencesOpen, setPreferencesOpen] = useState(false);

  useEffect(() => {
    if (consent !== "granted") {
      lastPage.current = null;
      return;
    }
    const route = safeRoute(pathname);
    if (lastPage.current === route) return;
    lastPage.current = route;
    analytics.capture("$pageview", { route });
  }, [pathname, consent]);

  useEffect(() => {
    const updatePreference = (event) => {
      if (event.key === CONSENT_KEY && ["granted", "denied"].includes(event.newValue)) {
        analytics.setConsent(event.newValue);
      }
    };
    window.addEventListener("storage", updatePreference);
    return () => window.removeEventListener("storage", updatePreference);
  }, []);

  if (!analytics.enabled) return null;
  const choose = (value) => {
    analytics.setConsent(value);
    setPreferencesOpen(false);
  };
  return (
    <>
      <div className="bg-slate-950 px-4 py-2 text-center text-xs text-gray-400">
        <button type="button" className="underline hover:text-white" onClick={() => setPreferencesOpen(true)}>
          Analytics preferences
        </button>
      </div>
      {(consent === null || preferencesOpen) && (
        <section aria-label="Usage analytics preferences" className="fixed bottom-4 left-4 right-4 z-[100] mx-auto max-w-xl rounded-xl border border-white/20 bg-slate-900 p-5 text-white shadow-2xl">
          <h2 className="text-lg font-semibold">Help improve Digitomy</h2>
          <p className="mt-2 text-sm text-gray-300">
            Allow PostHog usage analytics to measure navigation, onboarding, annotation activity,
            and browser/device information. Signed-in activity shares your email, internal
            account ID, organization, and role with PostHog. We exclude passwords, annotation notes, and image URLs.
            Session recording is disabled. You can change your choice here anytime.
          </p>
          <div className="mt-4 flex flex-wrap gap-3">
            <button type="button" className="rounded-lg bg-indigo-600 px-4 py-2 hover:bg-indigo-500" onClick={() => choose("granted")}>
              Allow analytics
            </button>
            <button type="button" className="rounded-lg border border-white/30 px-4 py-2 hover:bg-white/10" onClick={() => choose("denied")}>
              No thanks
            </button>
          </div>
        </section>
      )}
    </>
  );
}
